import { HttpResponse1532ob1hsse1y as HttpResponse } from './HttpResponse.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  Companion_getInstance16dzvgcii8pc4 as Companion_getInstance,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpResponseClass;
function DefaultHttpResponse() {
  if (DefaultHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, responseData) {
        super();
        this.w5z_1 = call;
        this.x5z_1 = responseData.g5l_1;
        this.y5z_1 = responseData.b5l_1;
        this.z5z_1 = responseData.e5l_1;
        this.a60_1 = responseData.c5l_1;
        this.b60_1 = responseData.h5l_1;
        var tmp = this;
        var tmp_0 = responseData.f5l_1;
        var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel()) ? tmp_0 : null;
        tmp.c60_1 = tmp0_elvis_lhs == null ? Companion_getInstance().w4k_1 : tmp0_elvis_lhs;
        this.d60_1 = responseData.d5l_1;
      }
      m5k() {
        return this.w5z_1;
      }
      dw() {
        return this.x5z_1;
      }
      v5k() {
        return this.y5z_1;
      }
      w5k() {
        return this.z5z_1;
      }
      x5k() {
        return this.a60_1;
      }
      y5k() {
        return this.b60_1;
      }
      u5k() {
        return this.c60_1;
      }
      z51() {
        return this.d60_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpResponse');
    DefaultHttpResponseClass = $;
  }
  return DefaultHttpResponseClass;
}
//region block: exports
export {
  DefaultHttpResponse as DefaultHttpResponse2wnrinzo0twhn,
};
//endregion

//# sourceMappingURL=DefaultHttpResponse.mjs.map
